import { AbstractModel } from '@/models/abstractModel';
import { useBookmakerDictionary } from '@/stores';
import type { IMonitoringSettlement } from '@/types';

export class MonitoringSettlement extends AbstractModel {
    public oldestUnsettledAccount: string;
    public oldestUnsettledBetAt: string;
    public oldestUnsettledBetHours: string;
    public oldestUnsettledGame: string;
    public siteId: number;
    public unsettledBetCount: number;

    constructor(data: IMonitoringSettlement) {
        super();
        this.siteId = data.site_id;
        this.unsettledBetCount = data.unsettled_bet_count;
        this.oldestUnsettledBetAt = data.oldest_unsettled_bet_at;
        this.oldestUnsettledAccount = data.oldest_unsettled_account;
        this.oldestUnsettledGame = data.oldest_unsettled_game;
        this.oldestUnsettledBetHours = data.oldest_unsettled_bet_hours;
    }

    get bookmakerName(): string {
        try {
            const bookmakerDictionary = useBookmakerDictionary();
            return bookmakerDictionary.nameById(this.siteId) || '';
        } catch {
            return '';
        }
    }

    get statusClass(): string {
        if (!this.oldestUnsettledBetAt) return 'status-green';
        const dateOne = new Date(this.oldestUnsettledBetAt);
        const dateTwo = new Date();
        const hours = Math.abs(dateTwo.getTime() - dateOne.getTime()) / 36e5;
        if (hours < 5 || isNaN(hours)) return 'status-green';
        if (hours > 24) return 'status-red';
        return 'status-yellow';
    }

    get unsettledBetCountClass(): string {
        return this.unsettledBetCount !== 0 ? '' : 'text-tbGreen';
    }
}
